export const patchData2026 = [
  {
    id: "jan-26",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Januari - Notes",
    year: "2026",
    description:
      "Perubahan pada halaman Stat Module, Product Master, Non Projected Reporting.",
    changelog: [
      "Stat Module: Penambahan fitur download dan upload.",
      "Product Master: Header Barcode.",
      "Non Projected Reporting: RDC GT Recap National Report",
    ],
    datas: [
      {
        id: 1,
        title: "Stat Module",
        date: "08 Januari 2026",
        items: ["Penambahan fitur download dan upload"],
      },
      {
        id: 2,
        title: "Product Master",
        date: "21 Januari 2026",
        items: [
          "Penambahan Header Barcode pada halaman Product Master",
          "Download Excel melampirkan informasi Barcode",
        ],
      },
      {
        id: 3,
        title: " Non Projected Reporting",
        date: "28 Januari 2026",
        items: [
          "RDC GT Recap National Report",
        ],
      },
    ],
  },
  {
    id: "mar-26",
    type: ["Backend"],
    color: ["#ff8a65"],
    title: "Maret - Notes",
    year: "2026",
    description:
      "Penyelesaian ticket Error Flag pada kolom kode di file excel.",
    changelog: [
      "Penyelesaian ticket Error Flag pada kolom kode di file excel (Product Master, Category, Principal, Brand, Stock Unit, Store Master Tipe Survey).",
    ],
    datas: [
      {
        id: 1,
        title: "Ticket SCAVOANW070403032026",
        date: "03 Maret 2026",
        items: [
          "Download Excel Product Master",
          "Download Excel Product Master Setup - Category",
          "Download Excel Product Master Setup - Principal",
          "Download Excel Product Master Setup - Brand",
          "Download Excel Product Master Setup - Stock Unit",
          "Download Excel Store Master Setup - Tipe Survey",
        ],
      },
    ],
  },
  {
    id: "apr-26",
    type: ["Backend"],
    color: ["#ff8a65"],
    title: "April - Notes",
    year: "2026",
    description:
      "Penyelesaian ticket Base Report tidak sama dan Rekap Harga Nasional.",
    changelog: [
      "Penyelesaian ticket Base Report tidak sama.",
      "Penyelesaian ticket Rekap Harga Nasional.",
    ],
    datas: [
      {
        id: 1,
        title: "Penyelesaian Ticket",
        date: "23 April 2026",
        items: [
          "SCPNNVKJ081718022026 - Base Report tidak sama",
          "SCWGYGBK235323112025 - Rekap Harga Nasional",
        ],
      },
    ],
  },
  {
    id: "may-26",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Mei - Notes",
    year: "2026",
    description:
      "Perbaikan Data Processing - Generate Data, Data Preparation, notifikasi sesi, serta pembaruan View Photo dan struktur table report projected.",
    changelog: [
      "Data Processing - Generate Data: perbaikan tombol Generate DB dan setup level 1_SuperProduct.",
      "Semua Halaman: penambahan notifikasi sesi habis setelah lama diam.",
      "Data Processing - Data Preparation: perbaikan urutan proses dan optimasi step.",
      "Data Processing - Data Preparation & Report Non Projected: perubahan pengambilan data period.",
      "Store Master & Product Master - View Photo: pembuatan ulang proses pengambilan list photo.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing - Generate Data",
        date: "06 Mei 2026",
        items: [
          "Memperbaiki tombol Generate DB yang bisa diklik berkali-kali pada periode yang sama padahal proses sebelumnya belum selesai",
          "Setup generate database report projected untuk level 1_SuperProduct",
        ],
      },
      {
        id: 2,
        title: "Semua Halaman",
        date: "22 Mei 2026",
        items: ["Notifikasi sesi habis setelah lama diam"],
      },
      {
        id: 3,
        title: "Data Processing - Data Preparation",
        date: "22 Mei 2026",
        items: [
          "Memperbaiki kendala proses balapan step 5 belum selesai tapi step 6 bisa dijalankan",
          "Memperbaiki urutan proses di step data preparation",
          "Optimasi dan mengurangi proses yang tidak diperlukan di beberapa step",
        ],
      },
      {
        id: 4,
        title: "Data Processing - Data Preparation & Report Non Projected",
        date: "22 Mei 2026",
        items: [
          "Perubahan pengambilan data period (dari distinct period table raw ke table standalone)",
          "Sync rawdata, Transfer data daily, Upload Data RTA MT/step 1 sinkronisasi dengan format list period terbaru",
        ],
      },
      {
        id: 5,
        title: "Store Master & Product Master - View Photo",
        date: "22 Mei 2026",
        items: [
          "Pembuatan ulang proses pengambilan list photo",
          "Generate list photo per survey di menu Store Master - View Photo",
          "Tidak lagi menggunakan endpoint dari mobile (Pak Moudy)",
        ],
      },
      {
        id: 6,
        title: "Product Master - View Photo",
        date: "24 Mei 2026",
        items: [
          "List pilihan Product Group",
          "Trigger sync data asset saat memilih project",
          "Penambahan validasi untuk menghindari spam proses trigger terpanggil",
        ],
      },
      {
        id: 7,
        title: "Store Master - View Photo",
        date: "24 Mei 2026",
        items: [
          "Menghilangkan tombol generate dan mengganti dengan trigger sync data saat memilih project",
        ],
      },
      {
        id: 8,
        title: "Report Projected & Stat Module - DB Set",
        date: "25 Mei 2026",
        items: [
          "Setup table rptdata_db_set_market_breakdown dan rptdata_db_set_period",
          "Optimasi list period, fact, market breakdown, level (mengurangi penggunaan distinct)",
          "Generate database sync dengan rptdata_db_set_market_breakdown dan rptdata_db_set_period",
          "Referensi list db set sesuai table db_set dengan is_static_data true untuk rpt_np_rta_gt dan rpt_np_rdc_gt",
          "Validasi generate database untuk menghindari proses dbname rpt_np_rta_gt dan rpt_np_rdc_gt",
          "Disable fitur create dan edit untuk dbname rpt_np_rta_gt dan rpt_np_rdc_gt",
        ],
      },
    ],
  },
  {
    id: "jun-26",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Juni - Notes",
    year: "2026",
    description:
      "Setup Catalog Report, Project Management Tipe Adhoc,integrasi Report Non Projected dengan data catalog, dan perbaikan filter Report Non Projected.",
    changelog: [
      "Catalog Report: setup data All Product dan All Product with Undup.",
      "Report Non Projected: integrasi dengan data catalog (RDC GT, RDC Pharmacy, RDC MT, RTA GT).",
      "Report Non Projected: fix filter single period.",
      "Project Management: Tipe Adhoc.",
    ],
    datas: [
      {
        id: 1,
        title: "Catalog Report",
        date: "17 Juni 2026",
        items: [
          "Setup catalog report dengan data All Product",
          "Setup catalog report dengan data All Product with Undup (Larutan Cap Badak + Cap Kaki Tiga, Kispray, Plossa, Rapika, Vegeta - Total)",
        ],
      },
      {
        id: 2,
        title: "Report Non Projected - Integrasi Data Catalog",
        date: "17 Juni 2026",
        items: [
          "RDC GT - Report Undup Gabungan Produk",
          "RDC Pharmacy - Report Undup Gabungan Produk",
          "RDC MT - Report Undup Gabungan Produk",
          "RTA GT - Report Distribusi Grosir",
        ],
      },
      {
        id: 3,
        title: "Report Non Projected",
        date: "18 Juni 2026",
        items: ["Fix filter report non projected single period"],
      },
      {
        id: 4,
        title: "Product Master - Setup",
        date: "26 Juni 2026",
        items: ["Sorting based id"],
      },
      {
        id: 5,
        title: "Project Management - Tipe Adhoc",
        date: "26 Juni 2026",
        items: ["Create Project Adhoc dengan custom sumber survey", "Copy Project Adhoc"],
      },
    ],
  },
  {
    id: "jul-26",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Juli - Notes",
    year: "2026",
    description:
      "Perubahan pada Stat Module - Setup Catalog Report.",
    changelog: [
      "Setup Catalog Report: penambahan pada undup catalog terkait  Custom Filter.",
    ],
    datas: [
      {
        id: 1,
        title: "Setup Catalog Report - Custom Filter",
        date: "15 Juli 2026",
        items: [
          "Penambahan Undup Catalog Custom Filter",
        ],
      },
    ],
  },
];
